import React from 'react';
export function About() {
  return <section id="about" className="py-20 bg-white" data-id="element-15">
      <div className="container mx-auto px-4" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-18">
            Why Swedenmark Studio
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto" data-id="element-19"></div>
        </div>
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-20">
          <div className="space-y-6 md:order-2" data-id="element-21">
            <h3 className="text-2xl font-semibold text-gray-800" data-id="element-22">
              Built to ship. Built to last.
            </h3>
            <p className="text-gray-600" data-id="element-23">
              Most agencies optimize for billable hours. We optimize for working
              software in your hands.
            </p>
            <p className="text-gray-600" data-id="element-24">
              Every engagement is scoped to a real product, a real timeline, and
              a real launch — designed with Scandinavian clarity and engineered
              for the long run.
            </p>
            <p className="text-gray-600" data-id="element-25">
              You finish with a product in users' hands and the source code in
              yours.
            </p>
            <div className="flex space-x-4 pt-2" data-id="element-26">
              <div className="h-12 w-1 bg-blue-500" data-id="element-27"></div>
              <blockquote className="italic text-gray-700" data-id="element-28">
                "Working software in your hands. That's the deliverable."
              </blockquote>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4" data-id="element-29">
            <div className="aspect-square rounded-lg overflow-hidden" data-id="element-30">
              <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Team collaborating" className="w-full h-full object-cover" data-id="element-31" />
            </div>
            <div className="aspect-square rounded-lg overflow-hidden mt-8" data-id="element-32">
              <img src="https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Copenhagen harbor" className="w-full h-full object-cover" data-id="element-33" />
            </div>
            <div className="aspect-square rounded-lg overflow-hidden" data-id="element-34">
              <img src="https://images.unsplash.com/photo-1520333789090-1afc82db536a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Designer at work" className="w-full h-full object-cover" data-id="element-35" />
            </div>
            <div className="aspect-square rounded-lg overflow-hidden mt-8" data-id="element-36">
              <img src="https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Modern workspace" className="w-full h-full object-cover" data-id="element-37" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}